interface CandidateInputsTooltipTitleProps {
  names: string[]
}

export const CandidateInputsTooltipTitle = ({ names }: CandidateInputsTooltipTitleProps) => (
  <>
    <p className="underline">Data to be translated:</p>
    {names.map(v => (
      <p key={v}>{v}</p>
    ))}
  </>
)
